import { Link } from 'react-router-dom';
import { courses } from '@/mocks/homeData';

export default function CourseIntroSection() {
  return (
    <>
      <section id="about" className="py-20 md:py-28 px-4 md:px-6">
        <div className="mx-auto max-w-4xl text-center">
          <div className="w-20 h-20 mx-auto mb-8 flex items-center justify-center rounded-full bg-primary-100">
            <i className="ri-lightbulb-line text-3xl text-primary-500"></i>
          </div>
          <p className="text-xs text-foreground-500 tracking-widest uppercase mb-4">关于bbgpt.online</p>
          <h2 className="font-heading text-3xl md:text-4xl text-foreground-950 mb-6">
            让每个人都能掌握<span className="text-primary-500">人工智能</span>
          </h2>
          <p className="text-base md:text-lg text-foreground-600 leading-relaxed max-w-2xl mx-auto">
            bbgpt.online成立于2023年，致力于为中文学习者提供最专业、最系统的人工智能培训课程。
            我们的导师团队来自Google、Meta、阿里巴巴等顶尖科技公司，课程内容紧跟行业前沿，
            通过「理论+实战+项目」三位一体的教学模式，帮助数千名学员成功进入AI领域。
            <span className="text-primary-500">✦</span>
          </p>
        </div>
      </section>

      <section className="py-16 md:py-24 px-4 md:px-6 bg-background-100">
        <div className="mx-auto max-w-7xl">
          <div className="flex flex-col lg:flex-row lg:items-end justify-between mb-12 gap-4">
            <div>
              <p className="text-xs text-foreground-500 tracking-widest uppercase mb-2">热门课程</p>
              <h2 className="font-heading text-3xl md:text-4xl text-foreground-950">
                精选<span className="italic text-primary-500">AI课程</span>
              </h2>
            </div>
            <p className="text-sm text-foreground-600 lg:max-w-md">
              从零基础到高级实战，覆盖AI领域最核心的技术方向，选择适合你的学习路径
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {courses.map((course, index) => (
              <div
                key={course.id}
                className={`group rounded-2xl overflow-hidden transition-all duration-300 hover:-translate-y-1 ${
                  index === 1
                    ? 'bg-foreground-900'
                    : 'bg-background-50'
                }`}
              >
                <div className="relative aspect-[16/10] overflow-hidden">
                  <img
                    src={course.image}
                    alt={course.title}
                    className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                    title={`${course.title} - bbgpt.online`}
                  />
                  <div className="absolute top-3 left-3">
                    <span className="inline-block px-3 py-1 bg-accent-500 text-foreground-950 text-xs font-semibold rounded-full whitespace-nowrap">
                      {course.tag}
                    </span>
                  </div>
                </div>

                <div className="p-5">
                  <h3 className={`font-heading text-xl mb-2 ${index === 1 ? 'text-background-50' : 'text-foreground-950'}`}>
                    {course.title}
                  </h3>
                  <p className={`text-sm leading-relaxed mb-4 ${index === 1 ? 'text-background-200' : 'text-foreground-600'}`}>
                    {course.description}
                  </p>

                  <div className="flex items-center gap-4 mb-4">
                    <span className={`text-xs ${index === 1 ? 'text-background-300' : 'text-foreground-500'}`}>
                      <i className="ri-time-line mr-1"></i>
                      {course.duration}
                    </span>
                    <span className={`text-xs ${index === 1 ? 'text-background-300' : 'text-foreground-500'}`}>
                      <i className="ri-user-line mr-1"></i>
                      {course.students.toLocaleString()} 学员
                    </span>
                  </div>

                  <div className="flex flex-wrap gap-2 mb-5">
                    {course.features.map((f) => (
                      <span
                        key={f}
                        className={`text-xs px-2.5 py-1 rounded-full whitespace-nowrap ${
                          index === 1
                            ? 'bg-foreground-800 text-background-200'
                            : 'bg-background-100 text-foreground-600'
                        }`}
                      >
                        {f}
                      </span>
                    ))}
                  </div>

                  <div className="flex items-center justify-between">
                    <span className={`font-heading text-2xl ${index === 1 ? 'text-primary-400' : 'text-primary-500'}`}>
                      ¥{course.price.toLocaleString()}
                    </span>
                    <Link
                      to="/courses"
                      className={`px-4 py-2 rounded-full text-sm font-medium transition-colors cursor-pointer whitespace-nowrap ${
                        index === 1
                          ? 'bg-accent-500 text-foreground-950 hover:bg-accent-600'
                          : 'bg-primary-500 text-background-50 hover:bg-primary-600'
                      }`}
                    >
                      了解详情
                    </Link>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}